/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1PostinggroupsQueryResponse } from '../../types/GetV1Postinggroups.ts'

export const getV1PostinggroupsQueryKey = () => [{ url: '/v1/PostingGroups' }] as const

export type GetV1PostinggroupsQueryKey = ReturnType<typeof getV1PostinggroupsQueryKey>

/**
 * {@link /v1/PostingGroups}
 */
export async function getV1Postinggroups(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1PostinggroupsQueryResponse, ResponseErrorConfig<Error>, unknown>(
        { method: 'GET', url: `/v1/PostingGroups`, ...requestConfig },
    )
    return res
}

export function getV1PostinggroupsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1PostinggroupsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1PostinggroupsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1PostinggroupsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Postinggroups(config)
        },
    })
}

/**
 * {@link /v1/PostingGroups}
 */
export function useGetV1Postinggroups<
    TData = ResponseConfig<GetV1PostinggroupsQueryResponse>,
    TQueryData = ResponseConfig<GetV1PostinggroupsQueryResponse>,
    TQueryKey extends QueryKey = GetV1PostinggroupsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1PostinggroupsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1PostinggroupsQueryKey()

    const query = useQuery(
        {
            ...getV1PostinggroupsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
